import React from 'react'
import { DialogActions, useMediaQuery } from '@material-ui/core'
import { useDialogStyle } from './ResponsiveDialog'
import { useTheme } from '@material-ui/core/styles'
import clsx from 'clsx'

const ResponsiveDialogAction = (props) => {
  const {
    StartButton,
    EndButton,
    StartBtnStyles = 'w-1/2 sm:w-auto',
    EndBtnStyles = 'w-1/2 sm:w-auto',
  } = props
  const classes = useDialogStyle()
  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <DialogActions className={clsx(classes.dialogContent, props.className)}>
      <div className={clsx('flex flex-row', isDownXs ? 'w-full' : '')}>
        <div className={clsx('ltr:mr-8 rtl:ml-8', StartBtnStyles)}>
          {StartButton}
        </div>
        <div className={clsx('ltr:ml-8 rtl:mr-8', EndBtnStyles)}>
          {EndButton}
        </div>
      </div>
    </DialogActions>
  )
}

export default ResponsiveDialogAction
